import { useState, useEffect, useCallback, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Tooltip
} from "antd";
import { useQueryClient } from "react-query";
import ModalVinculo from "../ModalVinculo";
import { FaSave, FaInfoCircle, FaRegCopy } from "react-icons/fa";
import URL from "core/resources/urls";
import { MdOutlineAdd, MdEdit, MdDownload } from "react-icons/md";
import { showSuccess, showError, showConfirm } from "infra/helpers/alerta";
import useModal, { Label } from "../../hooks/useModal";
import useModalSelecaoTalhoes from "../../hooks/useModalSelecaoTalhoes";
import { useFiltersLists } from "core/features/filters/store/lists";
import { useFilters } from "features/filters/store";
import {
  CustomModal,
  Header,
  Title,
  RoundedTable,
  ButtonAddItem,
  ContainerTable,
  SelectAntd,
  ModalContainer,
  ButtonStyled,
  ModalContentWrap,
  ModalTableContentWrap,
  ContentFooter,
  MessageWarning
} from "./styles";
import columns from "./columns";
import { useGetPlanejamentoOperacionalId } from "../../hooks/useGetPlanejamentoOperacionalId";
import { useTableForm, useReferenciaChangeWatcher, useChangeWatcher, recalcularSequenciaOperacoes } from "../../hooks/useTableForm";
import { useTableListTalhoes } from "../../hooks/useTableListTalhoes";
import { useGetSafraEOcupacaoPeriodo } from "../../hooks/useGetSafraEOcupacaoPeriodo";
import useComponenteDropdownList from "../../hooks/useComponenteDropdownList";
import { useGetAllPlanoOperacionalRef, useGetPlanoOperacionalRef } from "../../hooks/useGetPlanoOperacionalRef";
import { useCreatePlanejamentoOperacional, useCreatePlanejamentoOperacionalOperacao } from "../../hooks/useCreatePlanejamentoOperacional";
import { useUpdatePlanejamentoOperacional, useUpdatePlanejamentoOperacionalOperacao, useUpdatePlanejamentoOperacionalSafra } from "../../hooks/useUpdatePlanejamentoOperacional";
import { useGetImportacaoPlanoOperacionalOperacao } from "../../hooks/useGetImportacaoPlanoOperacional";
import { useDeletePlanejamentoOperacao, useDeletePlanejamentoSafraPeriodo } from "../../hooks/useDeletePlanejamento";
import { useGetValidateCode, useGetValidateDescription } from "../../hooks/useGetValidateCode";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";
import useAlvoDropdownList from "../../hooks/useAlvoDropdownList"
import { agruparPorSequencia, slugify } from "./utils";
import { TabbarModal } from "./TabbarModal";
import { TableRow } from "../../interfaces/TableRow";
import LoadingSkeleton from "../Loading";

const { Item, useForm } = Form;

interface CreateEditModalProps {
  refetch: () => void;
  filtersData?: any
}


interface PlanoOperacionalCopiaProps {
  unidadeId?: string,
  codigo: string,
  descricao: string,
  safraId?: string,
  safraPeriodoId: string[],
  ocupacaoId: string,
};

type TabDraft = {
  formValues: Record<string, unknown>;
  rows: TableRow[];
  rowsCopy: TableRow[];
  listOperacional: any;
  culturaSelected?: unknown;
};

function CreateEditModal({ refetch, filtersData }: CreateEditModalProps) {

  const { hasPermission } = useValidatePermission();
  const canEdit = hasPermission(['PlanoOperacional.Alterar']);

  const [cultruraSelected, setCulturaSelected] = useState();
  const [startLoading, setStartLoading] = useState(false);
  const [isSubmitButton, setIsSubmitButton] = useState(true);
  const [hasSubmit, setHasSubmit] = useState(false)
  const [planoOperacionalCopia, setPlanoOperacionalCopia] = useState<PlanoOperacionalCopiaProps>();
  const { unidades, safras } = useFiltersLists();
  const { filters: { unidade, safra } } = useFilters();
  const [unidadeSelect, setUnidadeSelect] = useState(unidade?.id);
  const { mutateAsync: getValidateCode } = useGetValidateCode();
  const { mutateAsync: getValidateDescription } = useGetValidateDescription();
  const [codeList, setCodeList] = useState<{ id: string; code: string }[]>([]);
  const queryClient = useQueryClient();
  const [label, setLabel] = useState('');
  const [newList, setNewList] = useState<Label[]>();
  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  const [tableScrollY, setTableScrollY] = useState<number>();
  const tabDraftsRef = useRef<Record<string, TabDraft>>({});
  const skipListOperacionalLoadRef = useRef(false);
  const tabsInitializedRef = useRef(false);
  const idUnidade = unidade?.id;

  const refReferencia = useRef(null);
  const refCarencia = useRef(null);
  const refDataInicio = useRef(null);
  const refDataFim = useRef(null);
  const refDosePorHA = useRef(null);
  const refUtilizacao = useRef(null);
  const refAlvo = useRef(null);

  const [searchSafra, setSearchSafra] = useState<Record<number, string>>({});
  const [searchFazenda, setSearchFazenda] = useState<Record<number, string>>({});
  const [searchCultura, setSearchCultura] = useState<Record<number, string>>({});

  const [searchOperation, setSearchOperation] = useState<Record<number, string>>({});
  const [searchComponent, setSearchComponent] = useState<Record<number, string>>({});
  const fieldRefs = useRef<Record<string, HTMLInputElement | null>>({});
  const [pendingFocus, setPendingFocus] = useState<{ id: string; field: string } | null>(null);

  const inputsRefs = [refReferencia, refCarencia, refDataInicio, refDataFim, fieldRefs, refDosePorHA, refUtilizacao, refAlvo];

  const [form] = useForm();

  const {
    id,
    isOpen,
    isEditing,
    isDeleting,
    isCopying,
    setId,
    setIsOpen,
    setIsCopying,
    setIsEditing,
    setIsVinculo,
    setVinculoSequencia,
    setIsVinculoIndex,
    setIsOpenImport,
    setIsOpenImportTalhoes,
    isModalDeleteOperacoes,
    isVinculo,
    setIsModalDeleteOperacoes,
    setIsModalDeleteOperacoesForm,
    setIsBlockingFields,
    isCopyingObject,
  } = useModal();

  const { isCopyWithImport, copyWithImportObject, setIsCopyWithImport, setHasData } = useModalSelecaoTalhoes();
  const { mutateAsync: getPlanejamento } = useGetPlanejamentoOperacionalId();
  const formTable = useTableForm();
  const { clearRows: clearRowsTalhoes } = useTableListTalhoes();
  const { data: periodos, refetch: refetchSafraEUnidade } = useGetSafraEOcupacaoPeriodo({ safraId: form.getFieldValue('safra'), ocupacaoId: form.getFieldValue('cultura') });
  const { fetchAllRef } = useGetAllPlanoOperacionalRef();
  const { fetchRef } = useGetPlanoOperacionalRef();
  const { rows, updateTableRow, addRow, updateRow, clearRows, setRows, setRowsCopy, rowsCopy, getChanges, setIndex, tempIdDeleteds } = formTable;

  const { mutateAsync: createPlanoOperacional, isLoading: loadingCreate } = useCreatePlanejamentoOperacional();
  const { mutateAsync: createPlanoOperacionalOperacao, isLoading: loadingCreateOperacao } = useCreatePlanejamentoOperacionalOperacao();
  const { mutateAsync: updatePlanoOperacional, isLoading: loadingUpdate } = useUpdatePlanejamentoOperacional();
  const { mutateAsync: updatePlanoOperacionalSafraPeriodo, isLoading: loadingUpdateSafra } = useUpdatePlanejamentoOperacionalSafra();
  const { mutateAsync: deletePlanoOperacionalSafraPeriodo, isLoading: loadingDelete } = useDeletePlanejamentoSafraPeriodo();
  const { mutateAsync: updatePlanoOperacionalOperacao, isLoading: loadingUpdateOperacao } = useUpdatePlanejamentoOperacionalOperacao();
  const { mutateAsync: deletePlanejamentoOperacao } = useDeletePlanejamentoOperacao();
  const { mutateAsync: getImportacaoOperacoes, isLoading: loadingImport } = useGetImportacaoPlanoOperacionalOperacao();

  const { data: dataComponente, refetch: refetchComponente } = useComponenteDropdownList({ apenasInsumos: true });
  const { data: dropdownDataList } = useAlvoDropdownList({ OcupacaoId: form.getFieldValue('cultura') });

  const [listOperacional, setListOperacional] = useState<any>();

  const isBlockingFields = listOperacional?.possuiVinculoOrdemServico && !isCopying && canEdit;
  const quantidadeTalhoesVinculados = listOperacional?.quantidadeTalhoesVinculados;

  const isLoading = loadingCreate || loadingUpdate || loadingCreateOperacao || loadingUpdateSafra || loadingDelete || loadingUpdateOperacao || loadingImport;

  const getPlanoOperacional = async (planoId?: string) => {
    const targetId = planoId ?? id;
    if (!targetId) {
      setListOperacional(undefined);
      return;
    }

    try {
      const { data: planejamentoOperacional } = await getPlanejamento(targetId);
      setListOperacional(planejamentoOperacional);
    } catch (error) {
      console.log(error);
    }
  }

  const saveCurrentTabDraft = useCallback(() => {
    if (!id || (!isCopying && !isCopyWithImport)) return;

    tabDraftsRef.current[id] = {
      formValues: form.getFieldsValue(),
      rows: JSON.parse(JSON.stringify(rows)),
      rowsCopy: JSON.parse(JSON.stringify(rowsCopy)),
      listOperacional: listOperacional ? JSON.parse(JSON.stringify(listOperacional)) : null,
      culturaSelected: cultruraSelected,
    };
  }, [id, isCopying, isCopyWithImport, form, rows, rowsCopy, listOperacional, cultruraSelected]);

  const restoreTabDraft = useCallback((tabId: string): boolean => {
    const draft = tabDraftsRef.current[tabId];
    if (!draft) return false;

    skipListOperacionalLoadRef.current = true;
    setListOperacional(draft.listOperacional);
    if (draft.culturaSelected !== undefined) {
      setCulturaSelected(draft.culturaSelected as never);
    }
    setRows(draft.rows);
    setRowsCopy(draft.rowsCopy);
    form.setFieldsValue({ ...draft.formValues, itens: draft.rows });
    setStartLoading(false);

    return true;
  }, [form, setRows, setRowsCopy]);

  const handleTabChange = useCallback((tabId: string) => {
    if (tabId === id) return;

    saveCurrentTabDraft();
    setLabel(tabId);
    setId(tabId);
  }, [id, saveCurrentTabDraft, setId]);

  const clearTabDrafts = useCallback(() => {
    tabDraftsRef.current = {};
    skipListOperacionalLoadRef.current = false;
    tabsInitializedRef.current = false;
  }, []);

  const handleCarenciaKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    itemId: string
  ) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      setPendingFocus({
        id: itemId,
        field: "componente",
      });

    }
  };

  useEffect(() => {
    if (!pendingFocus) return;

    const key = `${pendingFocus.id}-${pendingFocus.field}`;

    requestAnimationFrame(() => {
      fieldRefs?.current?.[key]?.focus();
      setPendingFocus(null);
    });
  }, [rows, pendingFocus]);

  useEffect(() => {
    if (!id || isCopyWithImport) {
      setListOperacional(undefined);
      return;
    }

    if (tabDraftsRef.current[id]) {
      restoreTabDraft(id);
      return;
    }

    getPlanoOperacional(id);
  }, [id, isCopyWithImport, restoreTabDraft]);

  filtersData = {
    ...filtersData,
    componentesList: dataComponente,
    alvosList: dropdownDataList
  };

  async function handleFinishFailed() {
    const codigo = form.getFieldValue('codigo');
    const descricao = form.getFieldValue('descricao');

    if (codigo) {
      await handleValidateCode();
    }
    if (descricao) {
      await handleValidateDescription();
    }
  }

  function onSubmitFinish() {
    if (isEditing && !isCopying && !isCopyWithImport) {
      handleUpdate();
    } else {
      onFinish();
    }
  }

  async function onFinish() {

    const hasError = rows.some(item => item?.error);

    if (hasError) {
      return
    }

    for (const item of rows) {
      if (item?.rules?.informarOperacaoVinculada && item.vinculo === '') {
        const { isConfirmed } = await showError(`Não é possível criar um planejamento sem vincular uma operação.`);
        if (isConfirmed) return;
      }
    }

    const payload = getPayload();

    let body = {
      ...payload?.planoOperacional,
      planoOperacionalOperacoes: payload?.planoOperacionalOperacoes
    }

    if (body?.planoOperacionalOperacoes?.length > 0) {
      const validateRef = body.planoOperacionalOperacoes.some((item: any) =>
        item?.planoOperacionalOperacaoReferenciaSequencia === 0 && item?.rules?.informarOperacaoVinculada);

      if (validateRef) {
        showError('E̝ necessa̝rio informar a operação vinculada');
        return;
      }

    }

    if (isCopyWithImport && listOperacional?.talhoes?.length > 0) {
      const listTalhoesLogicos =
        listOperacional?.talhoes
          ?.filter((talhao: any) => talhao?.talhaoId && talhao?.checked)
          ?.map((talhao: any) => talhao?.talhaoId);


      if (listTalhoesLogicos?.length > 0) {

        body.talhaoIds = listTalhoesLogicos
      }
    }

    try {
      const [resCode, resDescription] = await Promise.all([
        handleValidateCode(),
        handleValidateDescription()
      ]);

      if (!resCode || !resDescription) return;
      const response = await createPlanoOperacional({ ...body });
      if (response.status === 201) {
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_MAPA, idUnidade]);
        const text = isCopying ? 'copiado' : 'cadastrado';
        if (id && (isCopying || isCopyWithImport)) {
          const { isConfirmed } = await showSuccess(`Plano Operacional ${text} com sucesso!`);
          if (isConfirmed) {
            closeTabbarItem(id);
          }
        } else {
          showSuccess(`Plano Operacional ${text} com sucesso!`);

          if (!isCopying) handleClose();
        }
        refetch();
        return;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];
      console.log('error', error);
      showError(error);
    } catch (error) {
      showError("Nao foi possivel cadastrar o plano operacional");
    }

  }

  useEffect(() => {
    if (!isCopying && !isCopyWithImport) {
      tabsInitializedRef.current = false;
      return;
    }

    if (tabsInitializedRef.current) return;

    if (isCopyingObject.length > 0 && isCopying) {
      tabsInitializedRef.current = true;
      setId(isCopyingObject[0].id);
      setIsEditing(true);
      setLabel(isCopyingObject[0].id);
      setNewList(isCopyingObject);
    } else if (copyWithImportObject.length > 0 && isCopyWithImport) {
      tabsInitializedRef.current = true;
      setId(copyWithImportObject[0].idExternoPlanoOperacional);
      setIsEditing(true);
      setLabel(copyWithImportObject[0].idExternoPlanoOperacional);
      const newLabels = copyWithImportObject?.map((item: any) => ({
        id: item.idExternoPlanoOperacional,
        name: item.descricao,
        label: slugify(item.descricao),
      }));
      setNewList(newLabels);
    }
  }, [isCopying, isCopyWithImport, isCopyingObject, copyWithImportObject, setId, setIsEditing]);

  function closeTabbarItem(idLabel: string) {
    delete tabDraftsRef.current[idLabel];

    setNewList((prevList) => {
      const currentList = prevList || [];
      const filtered = currentList.filter((item: any) => item.id !== idLabel);

      if (filtered.length === 0) {
        setId('');
        setLabel('');
        handleClose();
        return [];
      }

      setId(filtered[0].id);
      setLabel(filtered[0].id);

      return filtered;
    });
  }

  useEffect(() => {
    if (unidadeSelect) {
      refetchComponente();
    }
  }, [unidadeSelect]);

  useEffect(() => {
    if (!rows?.length) return;

    rows.forEach((r, index) => {
      if (!r?.rules?.informarCarencia && r.carencia && !isEditing) {
        formTable.updateRow(index, { carencia: undefined });
      }

      if (!r?.rules?.informarPeriodo && (r.dtInicio || r.dtFim) && !isEditing) {
        formTable.updateRow(index, { dtInicio: '', dtFim: '' });
      }
    });
  }, [rows]);

  useEffect(() => {
    clearRows();
  }, []);

  function verifySequence(line: TableRow) {
    if (line.vinculo) {
      const sequenceCode = parseInt(line.vinculo.replace(/\D/g, ""), 10);
      const sequence = rows.find((r) => r.sequencia === sequenceCode);
      if (sequence?.planoOperacionalOperacaoId && (!isCopying && !isCopyWithImport)) {
        return undefined
      } else {
        return sequence?.sequencia;
      }
    } else {
      return undefined;
    }
  }
  function verifySequenceId(line: TableRow) {
    if (line.vinculo) {
      const sequenceCode = parseInt(line.vinculo.replace(/\D/g, ""), 10);
      const sequence = rows.find((r) => r.sequencia === sequenceCode);
      if (sequence?.planoOperacionalOperacaoId) {
        return sequence?.planoOperacionalOperacaoId
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  function addRowsDinamics(newRows: TableRow[], opt: boolean = false, dinamicValue: boolean = false) {
    const res = agruparPorSequencia(newRows)
      .map((row) => {
        return ({
          idExterno: row.idExterno,
          sequencia: row.sequencia,
          planoOperacionalOperacaoId: isCopying || opt ? undefined : row.planoOperacionalOperacaoId,
          operacaoId: row.operacao.value,
          planoOperacionalReferenciaId: row.referencia,
          planoOperacionalOperacaoReferenciaSequencia: verifySequence(row),
          planoOperacionalOperacaoReferenciaId: isCopying || opt ? undefined : (row.vinculo !== '' || row.vinculo !== null) ? verifySequenceId(row) : null,
          carenciaQuantidadeDias: row.carencia,
          periodoDataInicio: row.dtInicio ?? "",
          periodoDataFim: row.dtFim ?? "",
          componentes: row.componente ? row.dados.map((dado) => ({
            componenteId: dado.componente,
            quantidade: dado.dose,
            planoOperacionalOperacaoComponenteId: isCopying ? undefined : dado.planoOperacionalOperacaoComponenteId,
            porcentagemUtilizacao: dado.utilizacao,
            alvos: dado.alvo,
          })) : []
        });
      });

    if (!dinamicValue) {
      return res;
    }

    return res.filter((r) => r.planoOperacionalOperacaoId);
  }

  function getPayload() {
    const body = form.getFieldsValue();

    let uniqueRows = rows;

    if (id && isEditing && !isCopying) {
      uniqueRows = getChanges();
    }

    return {
      planoOperacional: {
        idExterno: listOperacional?.idExternoPlanoOperacional,
        unidadeId: body?.fazenda,
        codigo: body?.codigo,
        descricao: body?.descricao,
        safraId: body?.safra,
        safraPeriodoIds: body?.periodo,
        ocupacaoId: body?.cultura,
        talhaoIds: [] as string[]
      },
      planoOperacionalOperacoes: addRowsDinamics(uniqueRows),
    }
  }

  async function handleUpdate() {
    if (!id) return

    const hasError = rows.some(item => item?.error);

    if (hasError) {
      return
    }

    if (quantidadeTalhoesVinculados > 0) {
      const { isConfirmed } = await showConfirm(`Esse planejamento está relacionado a ${quantidadeTalhoesVinculados} talhões, e a alteração irá afetar o planejamento desses. Deseja prosseguir?`)
      if (!isConfirmed) return;
    }

    let body = getPayload();

    let newBody = {
      ...body?.planoOperacional,
      planoOperacionalId: id || null
    }

    try {
      if (body?.planoOperacionalOperacoes?.length > 0) {
        const validateRef = body.planoOperacionalOperacoes.some((item: any) =>
          item?.planoOperacionalOperacaoReferenciaSequencia === 0 && item?.rules?.informarOperacaoVinculada);

        if (validateRef) {
          showError('É necessário informar a operação vinculada');
          return;
        }
      }

      const rowsDinamics = addRowsDinamics(rows, false, false);

      if (tempIdDeleteds.length > 0) {
        const toDelete = tempIdDeleteds.filter(t => !rowsDinamics.some(r => r.planoOperacionalOperacaoId === t));

        if (toDelete.length > 0) {
          const dataDelete = {
            planoOperacionalId: id,
            planoOperacionalOperacaoIds: toDelete,
          }
          await deletePlanejamentoOperacao({ id, body: dataDelete });
        }
      }

      const rowsToCreate = rowsDinamics.filter(r => !r.planoOperacionalOperacaoId);
      const rowsToUpdate = addRowsDinamics(rows, false, true);

      if (rowsToUpdate.length > 0) {
        await updatePlanoOperacionalOperacao({
          id, body: {
            planoOperacionalId: id || null,
            planoOperacionalOperacoes: rowsToUpdate,
          }
        });
      }

      if (rowsToCreate.length > 0) {
        await createPlanoOperacionalOperacao({
          id, body: {
            planoOperacionalId: id || null,
            planoOperacionalOperacoes: rowsToCreate,
          }
        });
      }

      const atualIdsSafra = body?.planoOperacional?.safraPeriodoIds?.map((safraPeriodoId: string) => safraPeriodoId) ?? [];

      const deletedIdsSafra = planoOperacionalCopia?.safraPeriodoId
        ?.filter(row => !atualIdsSafra.includes(row))
        .map(row => row) ?? [];

      const deletedIdsSafraIDS = listOperacional?.planoOperacionalSafraPeriodos
        ?.filter((row: any) => deletedIdsSafra?.includes(row?.safraPeriodoId))
        ?.map((row: any) => row?.planoOperacionalSafraPeriodoId)

      const addedIdsSafra = atualIdsSafra
        ?.filter((row: string) => !planoOperacionalCopia?.safraPeriodoId?.includes(row)) ?? [];

      if (deletedIdsSafraIDS.length > 0) {
        const dataDelete = {
          planoOperacionalId: id,
          planoOperacionalSafraPeriodoIds: deletedIdsSafraIDS,
        }
        await deletePlanoOperacionalSafraPeriodo({ id, body: dataDelete });
      }

      if (addedIdsSafra.length > 0) {
        const dataAdded = {
          planoOperacionalId: id,
          safraPeriodoIds: addedIdsSafra,
        }
        await updatePlanoOperacionalSafraPeriodo({ id, body: dataAdded });
      }

      if (hasSubmit) {
        await updatePlanoOperacional({ id, body: newBody });
      }

      queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_MAPA, idUnidade]);
      showSuccess("Plano Operacional editado com sucesso!");
      handleClose();
      refetch();
    } catch (error: any) {
      const details = error?.response?.data?.Details;
      const msg = details ? details[0].Errors[0] : "Não foi possível editar o plano operacional";
      showError(msg);
    }
  }

  const handleReferenciaChange = useCallback(
    (index: number, value: string) => { },
    []
  );

  useReferenciaChangeWatcher(handleReferenciaChange);

  useChangeWatcher((duplicatedIndex, componenteId) => {
    if (isDeleting) return;
    showError(`"Duplicado" apenas para operação + carência + referência + insumo iguais`, 'Aviso');
    updateRow(duplicatedIndex, { componente: '' });
    const itens = form.getFieldValue("itens") || [];

    itens[duplicatedIndex] = {
      ...itens[duplicatedIndex],
      componente: '',
    };
    form.setFieldsValue({
      itens
    });
  });

  function validateFieldRows() {
    return rows.some((row) => {
      const carencia = row.carencia === undefined && ((row.dtInicio !== '' && row.dtFim !== '') || (row.dtInicio !== undefined && row.dtFim !== undefined));
      const datas = row.carencia === undefined && ((row.dtInicio === '' && row.dtFim === '') || (row.dtInicio === undefined && row.dtFim === undefined));
      const carenciaEDatas = (carencia && datas);
      const operacao = row.operacao.value === '';
      const referencia = row.referencia === '';
      return carenciaEDatas || operacao || referencia;
    });
  }

  function handleAddItem() {
    if (rows.length > 0) {
      const verifyFields = validateFieldRows();

      if (verifyFields) {
        return;
      }
    }
    const newLine = {
      id: rows.length + 1,
      sequencia: rows.length + 1,
      operacao: { text: "", value: "" },
      referencia: "",
      carencia: undefined as unknown as number,
      vinculo: "",
      dtInicio: "",
      dtFim: "",
      componente: '',
      dose: undefined as unknown as number,
      utilizacao: 100,
      alvo: [],
    };
    addRow(newLine);

  }

  useEffect(() => {
    form.setFieldsValue({ itens: [...rows] });
  }, [rows]);

  function handleClose() {
    clearTabDrafts();
    clearRows();
    setIsEditing(false);
    setIsCopying(false);
    setIsOpen(false);
    setIsBlockingFields(false);
    setId('');
    queryClient.resetQueries([URL.PLANO_OPERACIONAL.OBTER_BY_ID, id]);
    setIsCopyWithImport(false);
    setIsOpenImport(false);
    setIsOpenImportTalhoes(false);
    clearRowsTalhoes();
    setHasData(false);
    setCodeList([]);

    form.resetFields();
    form.setFieldsValue({
      safra: safra?.id,
      fazenda: unidade?.id
    });
  }

  useEffect(() => {
    if (form.getFieldValue('safra') && cultruraSelected) {
      form.setFields([
        { name: 'periodo', value: '' }
      ])
      refetchSafraEUnidade();
    }

  }, [form.getFieldValue('safra'), cultruraSelected]);

  useEffect(() => {
    form.setFieldsValue({
      safra: safra?.id,
      fazenda: unidade?.id
    });
  }, [unidade, safra, id]);

  useEffect(() => {
    async function readPlanoOperacional() {
      if (!id || !isCopyWithImport) return;

      if (tabDraftsRef.current[id]) {
        restoreTabDraft(id);
        return;
      }

      const newObject = copyWithImportObject?.find(item => item.idExternoPlanoOperacional === id);
      if (!newObject) return;

      newObject.planoOperacionalOperacoes = [];
      try {
        const { data: operacoes } = await getImportacaoOperacoes(newObject.idExternoPlanoOperacional);
        newObject.planoOperacionalOperacoes = operacoes;
        setListOperacional(newObject);
      } catch (error) {

      }
    }

    readPlanoOperacional();
  }, [id, copyWithImportObject, isCopyWithImport, restoreTabDraft])

  useEffect(() => {
    let cancelled = false;
    if (!id) return;

    if (skipListOperacionalLoadRef.current) {
      skipListOperacionalLoadRef.current = false;
      return;
    }

    if (id) {
      setStartLoading(true);

      clearRows();
      const carregarDados = async () => {

        let safraListField = listOperacional?.planoOperacionalSafraPeriodos?.map((item: any) => item.safraPeriodoId) ?? [];

        if (isCopyWithImport) {
          safraListField = listOperacional?.safraPeriodoIds?.map((item: string) => item) ?? [];
        }

        if (isEditing && isCopying) {
          form.setFieldsValue({
            codigo: codeList?.find(item => item.id === id)?.code,
            descricao: listOperacional?.descricao,
            cultura: listOperacional?.ocupacaoId,
            periodo: safraListField,
            safra: listOperacional?.safraId,
            fazenda: listOperacional?.unidadeId
          });
        } else {
          form.setFieldsValue({
            codigo: listOperacional?.codigo,
            descricao: listOperacional?.descricao,
            cultura: listOperacional?.ocupacaoId,
            periodo: safraListField,
            safra: listOperacional?.safraId,
            fazenda: listOperacional?.unidadeId
          });
        }

        setPlanoOperacionalCopia({
          codigo: listOperacional?.codigo,
          descricao: listOperacional?.descricao,
          safraPeriodoId: safraListField,
          ocupacaoId: listOperacional?.ocupacaoId,
          safraId: listOperacional?.safraId,
          unidadeId: listOperacional?.unidadeId,
        });

        if (listOperacional?.planoOperacionalOperacoes?.length > 0) {
          const novos: TableRow[] = [];
          let i = 1;
          for (const item of listOperacional.planoOperacionalOperacoes) {
            const alvoSequencia = listOperacional.planoOperacionalOperacoes?.find(
              (e: any) =>
                item.planoOperacionalReferencia === "Operação Vinculada" &&
                e.planoOperacionalOperacaoId === item.planoOperacionalOperacaoReferenciaId
            )?.sequencia;

            if (!isCopyWithImport) {
              if (item.componentes?.length) {
                for (const comp of item.componentes) {
                  const data: TableRow = {
                    tempId: i++,
                    sequencia: item.sequencia,
                    operacao: { text: item.operacao, value: item.operacaoId },
                    referencia: item.planoOperacionalReferenciaId,
                    carencia: item.carenciaQuantidadeDias,
                    vinculo: alvoSequencia ? `Operação ${alvoSequencia}` : '',
                    dtInicio: item.periodoDataInicio ?? '',
                    dtFim: item.periodoDataFim ?? '',
                    planoOperacionalOperacaoComponenteId: comp.planoOperacionalOperacaoComponenteId,
                    componente: comp.componenteId,
                    dose: comp.quantidade,
                    planoOperacionalOperacaoId: item.planoOperacionalOperacaoId,
                    utilizacao: comp.porcentagemUtilizacao,
                    alvo: filtersData?.alvosList
                      ?.filter((alvo: any) => comp.alvos?.some((a: any) => a.alvoId === alvo.value))
                      ?.map((alvo: any) => alvo.value) ?? [],
                  };

                  novos.push(data);
                }
              } else {
                const data: TableRow = {
                  tempId: i++,
                  sequencia: item.sequencia,
                  operacao: { text: item.operacao, value: item.operacaoId },
                  referencia: item.planoOperacionalReferenciaId,
                  carencia: item.carenciaQuantidadeDias,
                  vinculo: alvoSequencia ? `Operação ${alvoSequencia}` : '',
                  dtInicio: item.periodoDataInicio ?? '',
                  dtFim: item.periodoDataFim ?? '',
                  componente: '',
                  planoOperacionalOperacaoId: item.planoOperacionalOperacaoId,
                  dose: null,
                  utilizacao: null,
                  alvo: [],
                };

                novos.push(data);
              }
            } else {
              const data: TableRow = {
                idExterno: item.idExterno,
                sequencia: item.sequencia,
                operacao: { text: item.operacao, value: item.operacaoId },
                referencia: item.planoOperacionalReferenciaId,
                carencia: item.carenciaQuantidadeDias,
                vinculo: '',
                dtInicio: item.dtInicio,
                dtFim: item.dtFim,
                componente: item?.componenteId,
                dose: parseFloat(item?.quantidade.toFixed(3)),
                utilizacao: parseFloat(item?.porcentagemUtilizacao),
                alvo: [],
              };

              novos.push(data);
            }
          }

          const arrSortCopy = novos.sort((a, b) => a.sequencia - b.sequencia);

          const querys = arrSortCopy
            ?.map((item) => item.referencia)
            ?.map((item, index) =>
              `${index === 0 ? '?' : '&'}PlanoOperacionalReferenciaIds=${item}`
            )
            .join('');

          const refs = await fetchAllRef(querys);

          if (cancelled) return;

          for (let i = 0; i < arrSortCopy.length; i++) {
            for (let j = 0; j < refs?.length; j++) {
              if (arrSortCopy[i].referencia === refs[j]?.planoOperacionalReferenciaId) {
                arrSortCopy[i].rules = refs[j] ?? undefined;
              }
            }
          }

          const linhas = isCopyWithImport
            ? recalcularSequenciaOperacoes(arrSortCopy)
            : arrSortCopy;

          linhas.forEach(addRow);
          setRows(linhas);
          setRowsCopy(linhas);
          form.setFieldsValue({ itens: linhas });

          setStartLoading(false);
        }
      }
      carregarDados();

    }

    return () => { cancelled = true; };
  }, [listOperacional]);

  async function handleValidateCode() {
    let payload: any = {
      SafraId: form.getFieldValue('safra'),
      UnidadeId: form.getFieldValue('fazenda'),
      Codigo: form.getFieldValue('codigo')
    }

    if (id && !isCopying && !isCopyWithImport) {
      payload.PlanoOperacionalId = id
    }

    try {
      if (form.getFieldValue('codigo') === '') return;

      const response = await getValidateCode(payload);
      if (response.status === 204) {

        form.setFields([
          {
            name: 'codigo',
            errors: [],
          },
        ]);
        return true;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];

      form.setFields([
        {
          name: 'codigo',
          errors: [error],
        },
      ]);
    } catch (error) {
      const msg = "O código informado já está em uso para esta unidade e safra";

      form.setFields([
        {
          name: 'codigo',
          errors: [msg],
        },
      ]);
      console.error(error);
      return false;
    }
  }
  async function handleValidateDescription() {
    let payload: any = {
      unidadeId: form.getFieldValue('fazenda'),
      descricao: form.getFieldValue('descricao'),
      safraId: form.getFieldValue('safra'),
    }

    if (id && !isCopying && !isCopyWithImport) {
      payload.PlanoOperacionalId = id
    }

    try {
      if (form.getFieldValue('descricao') === '') return;

      const response = await getValidateDescription(payload);
      if (response.status === 204) {

        form.setFields([
          {
            name: 'descricao',
            errors: [],
          },
        ]);
        return true;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];

      form.setFields([
        {
          name: 'descricao',
          errors: [error],
        },
      ]);
    } catch (error) {
      const msg = "A descrição informada já está em uso para esta unidade e safra";

      form.setFields([
        {
          name: 'descricao',
          errors: [msg],
        },
      ]);
      console.error(error);
      return false;
    }
  }

  useEffect(() => {
    if (!id && !isEditing && rows.length > 0) {
      setIsSubmitButton(true);
    } else if (id && isEditing && hasSubmit) {
      setIsSubmitButton(true);
    } else if (id && isEditing && rows.length > 0 && rowsCopy.length > 0 && getChanges().length > 0) {
      setIsSubmitButton(true);
    } else if (id && isEditing && (getChanges().length > 0 || (rows.length !== rowsCopy.length))) {
      setIsSubmitButton(true);
    } else if (id && isEditing && isCopying) {
      setIsSubmitButton(true);
    } else if (id && isCopyWithImport && loadingImport) {
      setIsSubmitButton(true);
    } else {
      setIsSubmitButton(false);
    }
  }, [id, isEditing, rows, hasSubmit, getChanges()]);

  function EditableIcon() {
    if (isEditing && !isCopyWithImport && !isCopying) {
      return <MdEdit size={28} />;
    }
    if (isEditing && isCopyWithImport) {
      return <MdDownload size={28} />;
    }

    if (isEditing && isCopying) {
      return <FaRegCopy size={28} />;
    }

    return <MdOutlineAdd size={28} />;
  }

  const updateTableHeight = () => {
    const el = tableContainerRef.current;
    if (!el) return;

    const height = el.clientHeight;

    if (height > 0) {
      setTableScrollY(Math.max(height - 24, 100));
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    const run = () => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          updateTableHeight();
        }, 30);
      });
    };

    run();
  }, [isOpen, rows.length]);

  return (
    <CustomModal
      title={
        <Header>
          <EditableIcon />
          {isEditing && (!isCopying && !isCopyWithImport) ? "Editar" : isCopying ? "Copiar" : isCopyWithImport ? "Importar" : "Salvar novo"} Planejamento
        </Header>
      }
      visible={isOpen}
      width={"95%"}
      onCancel={handleClose}
      zIndex={1000}
      maskClosable={false}
      destroyOnClose
      centered
      getContainer={document.body}
      modalRender={(dom) => (
        <div style={{ position: "relative" }}>
          {(isModalDeleteOperacoes || isVinculo) && <div className="inner-overlay" />}
          {dom}
        </div>
      )}
      footer={
        <ContentFooter>
          <ButtonAddItem onClick={handleAddItem} disabled={isBlockingFields}>Adicionar Item</ButtonAddItem>
          {isBlockingFields && <MessageWarning>Este planejamento não pode ser editado porque já possui uma O.S. vinculada</MessageWarning>}
          <div>
            <Button
              size="large"
              onClick={handleClose}
              style={{ borderRadius: 8 }}
              loading={isLoading}
            >Cancelar</Button>
            <ButtonStyled
              size="large"
              type="primary"
              loading={isLoading}
              onClick={() => form.submit()}
              disabled={(!isSubmitButton || isBlockingFields) || rows.length === 0}
              icon={<FaSave />}
            >Salvar Planejamento</ButtonStyled>
          </div>
        </ContentFooter>
      }
    >
      <TabbarModal
        label={label}
        newList={newList}
        onTabChange={handleTabChange}
        closeTabbarItem={closeTabbarItem}
      />

      {
        startLoading
          ||
          (isCopyWithImport && loadingImport) ? <LoadingSkeleton /> :
          <ModalContainer>
            <Form
              form={form}
              layout="vertical"
              onFinish={onSubmitFinish}
              initialValues={{
                periodos: []
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
              }}
              onFinishFailed={handleFinishFailed}
              onValuesChange={(_, allValues) => {
                const { codigo, descricao, safra, fazenda, cultura, periodo } = allValues;

                if (id) {
                  if (
                    codigo !== planoOperacionalCopia?.codigo ||
                    descricao !== planoOperacionalCopia?.descricao ||
                    safra !== planoOperacionalCopia?.safraId ||
                    fazenda !== planoOperacionalCopia?.unidadeId ||
                    cultura !== planoOperacionalCopia?.ocupacaoId ||
                    periodo !== planoOperacionalCopia?.safraPeriodoId
                  ) {
                    setHasSubmit(true);
                  } else {
                    setHasSubmit(false);
                  }
                }
              }}

            >
              <ModalContentWrap>
                <Title>
                  <FaInfoCircle size={18} /> Dados Gerais
                </Title>
                <Row gutter={[16, 16]}>
                  <Col span={3}>
                    <Item
                      label="Código"
                      name="codigo"
                      rules={[{ required: true, message: "Campo Código é obrigatório" }]}
                    >
                      <Input
                        size="large"
                        placeholder="Código"
                        style={{ borderRadius: 8 }}
                        onBlur={handleValidateCode}
                        disabled={isBlockingFields}
                        onChange={(e) => {
                          if (id && isCopying) {
                            setCodeList(prev => {
                              const filtered = prev?.filter(item => item.id !== id);
                              const obj = {
                                id: id,
                                code: e.target.value,
                              }
                              return [...filtered, obj];
                            })
                          }
                        }}
                      />
                    </Item>
                  </Col>

                  <Col span={7}>
                    <Item
                      label="Descrição"
                      name="descricao"
                      rules={[{ required: true, message: "Campo Descrição é obrigatório" }]}
                    >
                      <Input
                        size="large"
                        placeholder="Descrição"
                        style={{ borderRadius: 8 }}
                        maxLength={200}
                        onBlur={handleValidateDescription}
                        disabled={isBlockingFields}
                      />
                    </Item>
                  </Col>
                  <Col span={2}>
                    <Item
                      label="Safra"
                      name="safra"
                      rules={[{ required: true, message: "Campo Safra é obrigatório" }]}
                    >
                      <SelectAntd
                        disabled={isBlockingFields}
                        options={(safras || [])?.map((item: any) => ({
                          label: item.descricao,
                          value: item.id,
                        }))}
                        optionFilterProp="label"
                        showSearch
                        onSearch={(searchText) => {
                          setSearchSafra(searchText);
                        }}
                        onChange={() => {
                          if (isCopying)
                            form.setFieldsValue({ periodo: [] });
                        }}
                        onInputKeyDown={(e) => {
                          if (e.key === "Tab") {
                            const searchText = searchSafra;

                            if (!searchText) return;

                            const filteredOptions =
                              safras
                                ?.map((item: any) => ({
                                  label: item.descricao,
                                  value: item.id,
                                }))
                                ?.filter((option: any) =>
                                  option.label?.toLowerCase().includes(searchText)
                                ) || [];

                            if (filteredOptions.length === 1) {
                              const onlyMatch = filteredOptions[0];
                              form.setFieldsValue({
                                safra: onlyMatch.value
                              });

                              if (isCopying)
                                form.setFieldsValue({ periodo: [] });
                            }
                          }
                        }}
                      />
                    </Item>
                  </Col>
                  <Col span={3}>
                    <Item
                      label="Fazenda"
                      name="fazenda"
                      rules={[{ required: true, message: "Campo Fazenda é obrigatório" }]}
                    >
                      <SelectAntd
                        onChange={(dataValue: any) => {
                          setUnidadeSelect(dataValue);
                        }}
                        disabled={isBlockingFields}
                        options={(unidades || [])?.map((item: any) => ({
                          label: item.nome,
                          value: item.id,
                        }))}
                        optionFilterProp="label"
                        showSearch
                        onSearch={(searchText) => {
                          setSearchFazenda(searchText);
                        }}
                        onInputKeyDown={(e) => {
                          if (e.key === "Tab") {
                            const searchText = searchFazenda;

                            if (!searchText) return;

                            const filteredOptions =
                              unidades
                                ?.map((item: any) => ({
                                  label: item.nome,
                                  value: item.id,
                                }))
                                ?.filter((option: any) =>
                                  option.label?.toLowerCase().includes(searchText)
                                ) || [];

                            if (filteredOptions.length === 1) {
                              const onlyMatch = filteredOptions[0];

                              form.setFieldsValue({
                                fazenda: onlyMatch.value
                              });
                            }
                          }
                        }}
                      />
                    </Item>
                  </Col>

                  <Col span={3}>
                    <Item
                      label="Cultura"
                      name="cultura"
                      rules={[{ required: true, message: "Campo Cultura é obrigatório" }]}
                    >
                      <SelectAntd
                        onChange={(dataValue: any) => {
                          setCulturaSelected(dataValue)
                        }}
                        disabled={isBlockingFields}
                        options={(filtersData?.ocupacoesList || [])?.map((item: any) => ({
                          label: item.nome,
                          value: item.ocupacaoId,
                        }))}
                        optionFilterProp="label"
                        showSearch
                        onSearch={(searchText) => {
                          setSearchCultura(searchText);
                        }}
                        onInputKeyDown={(e) => {
                          if (e.key === "Tab") {
                            const searchText = searchCultura;

                            if (!searchText) return;

                            const filteredOptions =
                              filtersData?.ocupacoesList
                                ?.map((item: any) => ({
                                  label: item.nome,
                                  value: item.ocupacaoId,
                                }))
                                ?.filter((option: any) =>
                                  option.label?.toLowerCase().includes(searchText)
                                ) || [];

                            if (filteredOptions.length === 1) {
                              const onlyMatch = filteredOptions[0];

                              form.setFieldsValue({
                                cultura: onlyMatch.value
                              });
                            }
                          }
                        }}
                      />
                    </Item>
                  </Col>

                  <Col span={6}>
                    <Item
                      label="Período de Produção"
                      name="periodo"
                      rules={[{ required: true, message: "Campo Período é obrigatório" }]}
                      getValueProps={value => ({ value: value || [] })}
                    >
                      <SelectAntd
                        mode="multiple"
                        showSearch
                        maxTagCount="responsive"
                        disabled={isBlockingFields}
                        optionFilterProp="label"
                        value={form.getFieldValue("periodos") || []}
                        options={(periodos || [])?.map((item: any) => ({
                          label: item.nomeOriginal,
                          value: item.id,
                        }))}
                        maxTagPlaceholder={(omittedValues) => (
                          <Tooltip
                            title={omittedValues.map((v) => v.label).join(", ")}
                            placement="top"
                          >
                            +{omittedValues.length} itens
                          </Tooltip>
                        )}
                      />
                    </Item>
                  </Col>
                </Row>

              </ModalContentWrap>

              <Title>
                Operações
              </Title>
              <ModalTableContentWrap>
                <ContainerTable isOverflow={!!formTable?.rows.length} ref={tableContainerRef}>
                  <RoundedTable
                    style={{ marginBottom: 16 }}
                    rowKey="id"
                    columns={columns(
                      setIsVinculo,
                      setIsVinculoIndex,
                      setVinculoSequencia,
                      fetchRef,
                      filtersData,
                      rows,
                      setIsModalDeleteOperacoes,
                      setIndex,
                      inputsRefs,
                      formTable.updateRow,
                      isBlockingFields,
                      updateTableRow,
                      Item,
                      form,
                      setIsModalDeleteOperacoesForm,
                      searchComponent,
                      setSearchComponent,
                      searchOperation,
                      setSearchOperation,
                      handleCarenciaKeyDown
                    )}
                    dataSource={rows}
                    className="my-table"
                    scroll={tableScrollY ? { y: tableScrollY } : undefined}
                    pagination={false}
                  />
                </ContainerTable>
              </ModalTableContentWrap>
            </Form>
            <ModalVinculo form={form} />
          </ModalContainer>
      }
    </CustomModal>
  );
}

export default CreateEditModal;
